import React from 'react';
import DashboardSidebar from './DashboardSidebar';

function AdminSidebar() {
  return <DashboardSidebar variant="admin" />;
}

export default AdminSidebar;
